<template>
  <v-app>
    <v-app-bar app color="white" height="100">
      <v-avatar class="mr-3" color="grey lighten-5" size="50">
        <v-img contain max-height="70%" src="./assets/art.svg"></v-img>
      </v-avatar>
      <v-toolbar-title class="font-weight-black headline title">Fidel Art Studio</v-toolbar-title>
      <v-spacer></v-spacer>
      <a target="blank" class="pr-4" href="https://www.elo7.com.br/fidelartstudio">
        <v-img contain width="40" height="40" src="./assets/shopping-bag.svg"></v-img>
      </a>
      <a target="blank" href="https://www.instagram.com/gepeto_da_massinha/">
        <v-img contain width="40" height="40" src="./assets/instagram (1).svg"></v-img>
      </a>
    </v-app-bar>

    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            style="opacity: 0.6"
            :min-height="'calc(50vh - ' + $vuetify.application.top + 'px)'"
            src="./assets/jiraya-3.jpg"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row align="center" class="mx-auto" justify="center">
                  <v-col
                    style="background-color: #00000099"
                    class="white--text text-center"
                    cols="12"
                    md="6"
                    xl="6"
                    tag="h1"
                  >
                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                    >Fidel Art Studio</span>

                    <br />

                    <span
                      class="font-weight-light"
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                    >Figuras feitas à mão</span>
                  </v-col>

                  <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#about-me')">
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Cada peça é única!</h2>

          <v-responsive class="mx-auto mb-8" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >Nossas peças são confeccionadas em porcelana fria, uma massa utilizada na arte do Biscuit. Com base nas referências do cliente, montamos uma estruta em arame galvanizado e isopor para dar leveza a peça. Após modelada e totalmente seca (oque leva alguns dias) a peça é pintada a mão, utilizamos tinta acrílica que possuí cores vivas e não sai facilmente.</v-responsive>

          <v-avatar class="elevation-12 mb-12" size="128">
            <v-img src="./assets/pop_custom1.jpg"></v-img>
          </v-avatar>
          <v-avatar class="elevation-12 mb-12 mx-3" size="128">
            <v-img src="./assets/kakashi-2.jpg"></v-img>
          </v-avatar>
          <v-avatar class="elevation-12 mb-12 mr-3" size="128">
            <v-img src="./assets/vaquinhas.jpg"></v-img>
          </v-avatar>
          <v-avatar class="elevation-12 mb-12 mr-3" size="128">
            <v-img src="./assets/hinata-nend.jpg"></v-img>
          </v-avatar>
          <v-avatar class="elevation-12 mb-12" size="128">
            <v-img src="./assets/jordan.jpg"></v-img>
          </v-avatar>

          <div></div>

          <v-btn color="grey" href="https://pt.wikipedia.org/wiki/Biscuit" outlined large>
            <span class="grey--text text--darken-1 font-weight-bold">Conheça a arte do Biscuit</span>
          </v-btn>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="features" class="grey lighten-3">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Estilos de modelagem</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col v-for="({ src, title, text, price }, i) in features" :key="i" cols="12" md="6">
              <v-card class="py-12 px-4" color="grey lighten-5" flat>
                <v-row>
                  <v-col cols="6">
                    <v-img contain :src="src" min-height="400"></v-img>
                  </v-col>
                  <v-col cols="6" align-self="center">
                    <span class="my-8" style="font-size: 1.4em">{{title}}</span>

                    <v-responsive
                      class="mx-auto title font-weight-light mt-4"
                      max-width="720"
                    >{{text}}</v-responsive>
                    <div class="price">
                      <small>a partir de</small>
                      <span class="font-weight-bold">R$ {{price}}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          style="opacity: 0.2"
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          :src="$vuetify.breakpoint.smAndDown ? pennyWise : bgImg"
        ></v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Como encomendar</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col v-for="({ src, text, title }, i) in articles" :key="i" cols="12" md="4">
              <v-img :src="src" class="mb-4" height="275" max-width="100%"></v-img>

              <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

              <div
                style="word-break: break-word;"
                class="title font-weight-light mb-5"
                v-html="text"
              ></div>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <v-sheet id="contact" color="#333333" dark tag="section" tile>
        <div class="py-12"></div>

        <v-container>
          <h5 class="display-1 mb-3 text-uppercase text-center">Fale Conosco atráves do Whatsapp ou Instagram</h5>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>
    <v-footer class="justify-center" color="#292929" height="100">
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >&copy; {{ (new Date()).getFullYear() }} — Fidel Art Studio — Made with 💜 by Danillo Fidel</div>
      <v-fab-transition>
        <v-btn color="whitesmoke" fixed bottom right fab>
          <a
            target="blank"
            href="https://api.whatsapp.com/send?phone=5534997958717&text=Ola%2C%20gostaria%20de%20fazer%20um%20or%C3%A7amento!"
          >
            <v-img contain width="35" height="35" src="./assets/whatsapp.svg"></v-img>
          </a>
        </v-btn>
      </v-fab-transition>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    pennyWise: require("./assets/peny.jpg"),
    bgImg: require("./assets/img.jpg"),
    stats: [
      ["Personalizado", "Github Stars"],
      ["Original", "Releases"],
      ["Resistente", "Downloads/mo"]
    ]
  }),
  computed: {
    articles() {
      return [
        {
          src: require("./assets/contrato-825x421.jpg"),
          title: "Termos e Condições",
          text: `
          Para confimar seu pedido é necessário um sinal de entrada de 50% do valor total do mesmo, após a confirmação do pagamento seu pedido estará reservado na nossa agenda.
Em caso de cancelamento do pedido por minha parte o valor será devolvido integralmente.
Após efetuado o pagamento o pedido não poderá ser cancelado por parte do cliente.
Em caso de desistência será devolvido apenas 50% do valor pago.
Não fazemos reservas sem pagamento.
O pedido só é confirmado e a data reservada, após o pagamento e envio do comprovante.
`
        },
        {
          src: require("./assets/red.jpg"),
          title: "Referências necessárias",
          text:
            "Para que possamos alcançar sua expectativa precisamos de boas referências, tais como fotos de vários ângulos do personagem, caso seja uma pessoa, nos envie fotos do corpo todo de frente e de costas, de preferência usando as roupas que serâo reproduzidas, detalhes como cor do cabelo, olhos, roupas e acessórios."
        },
        {
          src: require("./assets/como-o-planejamento-de-producao-e-afetado-pelos-prazos-de-fornecedores-20190510161717-od6njofwx4qbvdjwa5wy3wr1u5zu3t3hqfmbi4w420.jpg"),
          title: "Prazo de produção e entrega",
          text: `Pop Custom e Nendoroids: <b>15 dias*</b>.<br>
            Velas decoradas: <b>15 dias*</b>.<br>
            O prazo para entrega do pedido será contado a partir da data de confirmação do pagamento inicial + prazo de entrega dos correios. *Apenas dias úteis.`
        }
      ];
    },
    features() {
      return [
        {
          price: "100,00",
          src: require("./assets/pop_custom1.jpg"),
          title: "Pop Custom",
          text:
            "Inspirados nos famosos Funko Pops, marcantes pela cabeça grande e olhos arredondados e com características marcantes. Medem cerca de 13cm de altura"
        },
        {
          price: "50,00",
          src: require("./assets/vela.jpg"),
          title: "Velas decoradas",
          text:
            "Velas de biscuit, não derrete ao queimar o pavio, pode ser personalizada com qualquer tema, além de ser ótima para o aniversariante guardar como lembrança!"
        },
        {
          price: "80,00",
          src: require("./assets/hinata-nend.jpg"),
          title: "Nendoroid (Chibi)",
          text:
            "Inspirados nos bonecos Nendoroid, essas peças são ricas em detalhes, olhos estilo mangá.  Medem cerca de 10cm de altura."
        }
      ];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.dark--text {
  color: black;
}

.title {
  font-size: 0.8em !important;
}

.price {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 55px;
  right: 30px;
}

.social-icons {
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.social-icons__img-text {
  display: flex;
}
</style>
